import * as React from "react";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import "./searchBarComponent.scss";
import { styled } from '@mui/system';

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: '#666666',
  '& .MuiInputBase-input::placeholder': {
    color: '#666666',
  },
}));

function SearchBarComponent({ value, onChange, onSubmit }) {
  return (
    <div className="search-bar">
      <Paper
        component="form"
        onSubmit={onSubmit}
        sx={{ 
          p: "2px 20px", 
          display: "flex", 
          alignItems: "center",
          borderRadius: "5px",
          backgroundColor:"#141414",
          color:"#666666", 
          boxShadow: " 0px 0px 0px 6px rgba(25,25,25,1)",
          border:"1px solid #262626"
        }}
      >
        <StyledInputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="Search users..."
          inputProps={{ 'aria-label': 'search' }}
          value={value}
          onChange={onChange}
        />
        <IconButton type="submit" sx={{ p: "10px", color:"#FFFFFF" }} aria-label="search">
          <SearchIcon />
          <p>Search</p>
        </IconButton>
      </Paper>
    </div>
  );
}

export default SearchBarComponent;